import React from "react";
import EventCountdownTimer from "./EventCountdownTimer";
import { Link } from "react-router-dom";
import { REMA_REGISTRATION_PAGE_URL } from "./constants";
import { Download, X } from "phosphor-react";
import DownloadBrochureButton from "./DownloadBrochureButton";

const NavBarSticky = ({ navToggle }) => {
  const [visible, setVisible] = React.useState(true);

  if (!visible) return null;

  const handleClose = () => setVisible(false);

  return (
    <nav
      className={` text-white fixed z-50  font-sora w-full  bg-[#11302D] flex items-center ${
        !navToggle ? "opacity-0 top-[70px]" : "opacity-100 top-0"
      } transition-all duration-300 ease-in-out`}
    >
      <div className="container mx-auto flex-col md:flex-row md:h-[70px] font-sora flex items-center justify-between w-full p-4 relative">
        <p className="uppercase mb-4 md:mb-0 font-semibold">
          SEE YOU NEXT YEAR!
        </p>
        <EventCountdownTimer spread={true} />
        {/* Register Button - Desktop */}
        <div className="flex items-center gap-4">
          <div className="hidden lg:block">
            {/* <Link
              to={REMA_REGISTRATION_PAGE_URL}
              className="bg-light-green-500 hover:bg-light-green-600 text-green-800 font-semibold py-3 px-8  transition duration-300 ease-in-out transform  text-sm block text-center"
            >
              Register now
            </Link> */}
            <DownloadBrochureButton />
          </div>
          <div className="hidden md:block cursor-pointer" onClick={handleClose}>
            <X />
          </div>
        </div>
        <div className="absolute right-4 top-4 md:hidden" onClick={handleClose}>
          <X />
        </div>
      </div>
    </nav>
  );
};

export default NavBarSticky;
